import {TableAction} from '../../../../components/ModularDataTable/types'
import {i18n} from '../../../../translate/i18n'

export function createActions(): TableAction[] {
  return [
    {
      icon: 'fas fa-eye',
      label: i18n.t('buttons.view'),
      action: (item: any) => {
        window.open(`/customer/report/${btoa(item.id)}`)
      },
      color: 'primary',
    },
  ]
}
